module.exports = __webpack_public_path__ + "img/ocroverother_ok.png";